import React from 'react';

export function ChevronUp(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="18"
        height="10"
        viewBox="0 0 18 10"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9111 8.6224C17.3137 8.15275 17.2898 7.46152 16.8757 7.02078L16.781 6.93034L10.4318 1.48816C9.65366 0.821214 8.52603 0.784161 7.70909 1.377L7.56828 1.48816L1.21907 6.93034C0.715881 7.36165 0.657607 8.11921 1.08891 8.6224C1.49147 9.09204 2.17822 9.17412 2.67711 8.8323L2.78097 8.75256L9.00002 3.42245L15.2191 8.75256C15.6887 9.15511 16.3799 9.13118 16.8207 8.71709L16.9111 8.6224Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
